import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../providers/basic';
import { environment as config } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { ISession } from '../../models/session';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

export interface IRegistrationEnabled {
  registration_enabled: boolean;
}

@Injectable()
export class RegistrationService extends BasicService {
  private API = config.usersv3.url;

  constructor(
    protected authService: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
  ) {
    super(authService, translate);
  }

  private url(session: ISession): string {
    return `${this.API}/sessions/${session.id}/registration`;
  }

  public getRegistration(session: ISession, notify: boolean = false): Observable<IRegistrationEnabled> {
    return this.http
      .get(this.url(session))
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateRegistration(session: ISession, registrationEnabled: boolean, notify: boolean = true): Observable<IRegistrationEnabled> {
    return this.http
      .put(this.url(session), { registration_enabled: registrationEnabled })
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/registration.service.ts